import React from 'react';
import { clearCacheAndReload, forceUpdateCheck } from '../utils/forceUpdateDetection';
import { APP_VERSION, BUILD_INFO } from '../utils/version';

interface VersionPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const VersionPopup: React.FC<VersionPopupProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleCacheClear = () => {
        clearCacheAndReload();
    };

    const handleForceUpdateCheck = () => {
        forceUpdateCheck();
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg p-6 max-w-md mx-4 text-center">
                <div className="mb-4">
                    <div className="text-blue-500 text-4xl mb-2">ℹ️</div>
                    <h2 className="text-xl font-bold text-gray-900 mb-2">
                        App Version Info
                    </h2>
                    <p className="text-gray-600 mb-4">
                        Current version and build information
                    </p>
                    <div className="bg-gray-100 rounded p-3 mb-4">
                        <p className="text-sm text-gray-700">
                            <strong>Version:</strong> {APP_VERSION}
                        </p>
                        <p className="text-sm text-gray-700">
                            <strong>Built on:</strong> {new Date(BUILD_INFO.buildTime).toLocaleString()}
                        </p>
                        <p className="text-sm text-gray-700">
                            <strong>Environment:</strong> {BUILD_INFO.environment}
                        </p>
                        <p className="text-sm text-gray-700">
                            <strong>Commit:</strong> {BUILD_INFO.commitHash}
                        </p>
                    </div>
                </div>
                
                <div className="flex flex-col space-y-2">
                    <button
                        onClick={handleForceUpdateCheck}
                        className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                    >
                        Check for Updates
                    </button>
                    
                    <button
                        onClick={() => {
                            // Clear cache and reload
                            if ('caches' in window) {
                                caches.keys().then(names => {
                                    names.forEach(name => caches.delete(name));
                                });
                            }
                            localStorage.clear();
                            window.location.reload();
                        }}
                        className="bg-orange-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-orange-700 transition-colors"
                    >
                        Clear Cache & Reload
                    </button>
                    
                    <button
                        onClick={onClose}
                        className="text-gray-500 text-sm hover:text-gray-700"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VersionPopup; 